import React from 'react';
import styled, { css, keyframes } from 'styled-components';
import { space } from 'styled-system';

const loadingColorProgression = keyframes`
  0% {
    background-color: #d9dfe1;
  }
  25% {
    background-color: #e8ecee;
  }
  50% {
    background-color: #eef1f2;
  }
  75% {
    background-color: #e8ecee;
  }
  100% {
    background-color: #d9dfe1;
  }
`;

const animations = css`
  animation: ${({ theme }) => theme.animations.create(loadingColorProgression, `1s linear infinite`)};
`;

export const StyledSkeleton = styled.div`
  ${space}
  ${animations}
  background-color: ${({ theme }) => theme.colors.grey[95]};
  background-size: 200px 100%;
  background-repeat: no-repeat;
  border-radius: 10px;
  display: inline-block;
  line-height: 1;
  width: 100%;
  height: 100%;
`;

/**
 * @type {React.FC<{
 *  height?: number | string;
 *  width?: number | string;
 *  circle?: boolean;
 *  rounded?: boolean;
 *  mr?: number | string
 * }>}
 */
const Skeleton = ({ width, height, circle, rounded, ...props }) => {
  const style = {};

  if (width !== null) {
    style.width = width;
  }

  if (height !== null) {
    style.height = height;
  }

  if (width !== null && height !== null && circle) {
    style.borderRadius = '50%';
  }

  if (rounded) {
    style.borderRadius = `30px`;
  }

  return (
    <div>
      <StyledSkeleton style={style} {...props}>
        &zwnj;
      </StyledSkeleton>
    </div>
  );
};

Skeleton.defaultProps = {
  width: null,
  height: null,
  circle: false,
};

export default Skeleton;
